<div class="MainContainer animated fadeIn">
    <div class="MainCompanyTitle" style="margin-bottom: 0;">
        <p class="SectionTitle" style="margin-top: 0%;">{{ 'ApiSettingsTitle' | translate }}</p>
    </div>

    <mat-tab-group style="margin-top: 10px;">
        <mat-tab label="{{api.Name}}" *ngFor="let api of APISettingsCollection">
            <div class="fullWidthContainer" *ngIf="parent.loading" style="margin-top: 5%;">
                <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
              </div>
    
              <div class="MainTabBody" *ngIf="!parent.loading">
    
                <div class="fullWidthContainer">
                  <mat-form-field class="example-full-width halfWidth" appearance="outline">
                    <mat-label>{{ 'AccountSettingsPage.UserID' | translate }}</mat-label>
                    <input disabled matInput [(ngModel)]="api.APIKey">
                  </mat-form-field>
                </div>

                <div class="fullWidthContainer">
                  <mat-form-field class="example-full-width halfWidth" appearance="outline">
                    <mat-label>{{ 'Partners.Name' | translate }}</mat-label>
                    <input disabled matInput [(ngModel)]="api.Name">
                  </mat-form-field>
                </div>

                <div class="fullWidthContainer">
                    <mat-form-field class="example-full-width halfWidth" appearance="outline">
                      <mat-label>{{ 'Live-URL' | translate }}</mat-label>
                      <input matInput [(ngModel)]="api.LiveLink">
                    </mat-form-field>
                </div>

                <div class="fullWidthContainer">
                    <mat-form-field class="example-full-width halfWidth" appearance="outline">
                      <mat-label>{{ 'Local-Test-URL' | translate }}</mat-label>
                      <input matInput [(ngModel)]="api.LocalHostLink">
                    </mat-form-field>
                </div>

                <div class="fullWidthContainer">
                    <mat-form-field class="example-full-width halfWidth" appearance="outline">
                      <mat-label>{{ 'API-URL' | translate }}</mat-label>
                      <input matInput [(ngModel)]="api.URL">
                    </mat-form-field>
                </div>
    
                <div class="fullWidthContainer" style="padding-left: 0.5%;">
                  <mat-slide-toggle [(ngModel)]="api.IsTestEnviorment">
                    {{'IsTestAPIMode' | translate}}
                    <span *ngIf="api.IsTestEnviorment">{{api.LocalHostLink}}</span>
                    <span *ngIf="!api.IsTestEnviorment">{{api.LiveLink}}</span>
                    <span>{{api.URL}}</span>
                </mat-slide-toggle>
                </div>
    
              </div>
    
              <div class="fullWidthContainer" style="padding-left: 2.5%;margin-bottom: 10px;">
                <div class="halfWidth">
                  <button mat-raised-button color="accent" (click)="UpdateAPISettings(api);">{{'SaveButton' | translate}}</button>
                </div>
              </div>
        </mat-tab>
    </mat-tab-group>
</div>